import Alpine from 'alpinejs';
import GLightbox from 'glightbox';

// Initialize GLightbox
const lightbox = GLightbox({
    selector: '.glightbox'
});

// Make Alpine available globally
window.Alpine = Alpine;

// Start Alpine
Alpine.start();

console.log('chs')